import { type ReactNode } from 'react';

import styles from '@admin/molecules/InputElement/InputElement.module.scss';

interface Props {
    children: ReactNode;
    title: string;
    inputKey?: string;
    inline?: boolean;
    id?: string;
}

export const LabelHolder = ({ children, title, inputKey, id, inline = true, ...rest }: Props) => {
    return (
        <div {...rest}>
            <div className={inline ? styles['label-holder'] : undefined}>
                <label htmlFor={inputKey || id}>{title}</label>
            </div>
            {children}
        </div>
    );
};
